import { StateSchema } from 'app/config/storeConfig/types';

export const getWarehouseId = (state: StateSchema): Nullable<string> => state.warehouseStatisticCard.warehouseId;
